import { QueryClientProvider } from '@tanstack/react-query';
import type { PropsWithChildren } from 'react';
import { useContext, useMemo } from 'react';

import { BrandContext } from '~/modules/branding';

import { createQueryClient } from './utils/queryClient';

export type ContainerQueryClientProviderProps = PropsWithChildren;

/**
 * Custom component that wraps a QueryClientProvider. Used to create the QueryClient
 * with a custom set of options based on the current Brand.
 */
function ContainerQueryClientProvider({
  children,
}: ContainerQueryClientProviderProps) {
  const brand = useContext(BrandContext);

  const queryClient = useMemo(() => {
    return createQueryClient(brand.defaultQueryOptions);
  }, [brand.defaultQueryOptions]);

  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
}

ContainerQueryClientProvider.displayName = 'ContainerQueryClientProvider';

export { ContainerQueryClientProvider };
